// extracted by mini-css-extract-plugin
export var errorIcon = "_mx-1";
export var nameLogo = "_mx-0";